import(/* webpackMode: "eager", webpackExports: ["Top"] */ "/codebuild/output/src1215602072/src/git-codecommit.ap-southeast-2.amazonaws.com/v1/repos/ai-assist-ui/components/top.tsx");
